import React from 'react';
import {Container} from './Info.styles';

const Info = ({text, width, inline, heading}) => {
  return (
    <Container width={width} inline={inline}>
      {
        <span>
          {<b>{heading}</b>}
          {text}
        </span>
      }
    </Container>
  );
};

export default Info;
